module.exports = __webpack_public_path__ + "static/020-0c52d2f4b2a777e8f2c5df181d760961.jpg";